import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import React from "react";

type RemoveLinkButtonProps = {
  onClick: () => void;
} & WithStyles<typeof styles>;

function RemoveLinkButton({ classes, onClick }: RemoveLinkButtonProps) {
  const { t } = useTranslations();

  return (
    <div className={classes.container}>
      <button className={classes.button} onClick={onClick}>
        <img src="/images/trash.svg" alt={t("common:actions.remove")} />
      </button>
    </div>
  );
}

const styles = () =>
  createStyles({
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    button: {
      border: "none",
      background: "none",
      padding: 0,
    },
  });

export default withStyles(styles)(RemoveLinkButton);
